/**
 * @todo(Andrew): move this to building-query
 */
import type { WallCatalogSettings } from "building-types/settings/wallCatalogSettings";
import type { StructuralMaterial } from "./wallMaterialTypes";

export function nameFromWallMaterialId(wallCatalogSettings: WallCatalogSettings, wallMaterialId: string) {
  const wallMaterial = wallCatalogSettings.wallMaterials[wallMaterialId];
  return wallMaterial?.name ?? `Unknown Material: ${wallMaterialId}`;
}

export function structuralMaterialHash(material: StructuralMaterial): string {
  return material.catalogItemType + ":" + material.name + ":" + material.thickness;
}
